/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { OrgOrganizationSite } from '../../models/org-organization-site';

export interface GetPlatformOrganizationsSitesBySiteKey$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
}

export function getPlatformOrganizationsSitesBySiteKey(http: HttpClient, rootUrl: string, params: GetPlatformOrganizationsSitesBySiteKey$Params, context?: HttpContext): Observable<StrictHttpResponse<OrgOrganizationSite>> {
  const rb = new RequestBuilder(rootUrl, getPlatformOrganizationsSitesBySiteKey.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrgOrganizationSite>;
    })
  );
}

getPlatformOrganizationsSitesBySiteKey.PATH = '/platform/organization-sites/{organizationSiteKey}';
